import { recipe } from "@vanilla-extract/recipes";

import { responsive } from "../../utils/responsive";
import { transition } from "../../utils/transition";

import { theme } from "../../theme/css/theme.css";

export const containerStyle = recipe({
  base: {
    display: "flex",
    overflow: "hidden",
    position: "relative",
    selectors: {
      "&:before, &:after": {
        position: "absolute",
        content: '""',
        zIndex: 3,
        pointerEvents: "none",
        transition: transition("opacity"),
      },
      "&[data-mode=vertical]:before": {
        top: 0,
        left: 0,
        width: "calc(100% - var(--offset, 0px))",
        background: `linear-gradient(to bottom, var(--background), transparent)`,
        borderTop: "10px solid var(--background)",
      },
      "&[data-mode=vertical]:after": {
        bottom: 0,
        left: 0,
        width: "calc(100% - var(--offset, 0px))",
        background: `linear-gradient(to top, var(--background), transparent)`,
        borderBottom: "10px solid var(--background)",
      },
      "&[data-mode=horizontal]:before": {
        top: 0,
        left: 0,
        height: "calc(100% - var(--offset, 0px))",
        background: `linear-gradient(to right, var(--background), transparent)`,
        ...responsive({
          base: {
            display: "none",
          },
          s: {
            display: "block",
          },
        }),
      },
      "&[data-mode=horizontal]:after": {
        top: 0,
        right: 0,
        height: "calc(100% - var(--offset, 0px))",
        background: `linear-gradient(to left, var(--background), transparent)`,
        ...responsive({
          base: {
            display: "none",
          },
          s: {
            display: "block",
          },
        }),
      },
    },
  },
  variants: {
    disabled: {
      true: {
        pointerEvents: "none",
      },
    },
    hideScrollbar: {
      true: {
        vars: { "--offset": "0px" },
      },
      false: {
        vars: { "--offset": "2px" },
      },
    },
    overlapSize: {
      none: {
        selectors: {
          "&[data-mode=vertical]:before, &[data-mode=vertical]:after": {
            display: "none !important",
          },
          "&[data-mode=horizontal]:before, &[data-mode=horizontal]:after": {
            display: "none !important",
          },
        },
      },
      default: {
        selectors: {
          "&[data-mode=vertical]:before, &[data-mode=vertical]:after": {
            height: theme.spacings.xl,
          },
          "&[data-mode=horizontal]:before, &[data-mode=horizontal]:after": {
            width: theme.spacings.xl,
          },
        },
      },
      s: {
        selectors: {
          "&[data-mode=vertical]:before, &[data-mode=vertical]:after": {
            height: theme.spacings.m,
          },
          "&[data-mode=horizontal]:before, &[data-mode=horizontal]:after": {
            width: theme.spacings.m,
          },
        },
      },
    },
    overflowTop: {
      true: {
        ":before": { opacity: 1 },
      },
      false: {
        ":before": { opacity: 0 },
      },
    },
    overflowBottom: {
      true: {
        ":after": { opacity: 1 },
      },
      false: {
        ":after": { opacity: 0 },
      },
    },
    overlapColor: {
      menu: {},
      background: {
        vars: { "--background": theme.colors.background },
      },
      backgroundTint: {
        vars: { "--background": theme.colors.backgroundTint },
      },
      navigation: {
        vars: { "--background": theme.colors.navigation },
      },
      secondary: {},
      infoSurface: {
        vars: { "--background": theme.colors.secondary },
      },
      sideContent: {},
      panel: {
        vars: { "--background": theme.colors.panel },
      },
      primary50: {},
    },
  },
  defaultVariants: {
    overlapSize: "default",
  },
});

export const innerStyle = recipe({
  base: {
    position: "relative",
    width: "100%",
    scrollBehavior: "smooth",
    flexGrow: 1,
  },
  variants: {
    mode: {
      vertical: {
        overflowY: "scroll",
        overflowX: "hidden",
      },
      horizontal: {
        overflowX: "scroll",
        overflowY: "hidden",
      },
    },
    hideScrollbar: {
      true: {
        scrollbarWidth: "none",
        msOverflowStyle: "none",
        selectors: {
          "&::-webkit-scrollbar": {
            display: "none",
          },
        },
      },
      false: {
        selectors: {
          "&::-webkit-scrollbar": {
            width: theme.spacings.xxs2,
            height: theme.spacings.xxs2,
          },
          "&::-webkit-scrollbar-track": {
            background: "transparent",
          },
          "&::-webkit-scrollbar-thumb": {
            borderRadius: theme.spacings.xxs2,
          },
        },
      },
    },
    overlapColor: {
      menu: {},
      background: {
        selectors: {
          "&::-webkit-scrollbar-thumb": {
            background: theme.colors.inputBorderFocus,
          },
        },
      },
      backgroundTint: {
        selectors: {
          "&::-webkit-scrollbar-thumb": {
            background: theme.colors.inputBorderFocus,
          },
        },
      },
      navigation: {
        selectors: {
          "&::-webkit-scrollbar-thumb": {
            background: theme.colors.navigation,
          },
        },
      },
      secondary: {
        selectors: {
          "&::-webkit-scrollbar-thumb": {
            background: theme.colors.secondary,
          },
        },
      },
      infoSurface: {},
      sideContent: {},
      panel: {},
      primary50: {},
    },
    snapMode: {
      horizontal: {
        scrollSnapType: "x proximity",
      },
      vertical: {
        scrollSnapType: "y proximity",
      },
    },
  },
  defaultVariants: {
    overlapColor: "menu",
    hideScrollbar: false,
  },
});
